module.exports = __webpack_public_path__ + "img/Paytm.6db927a4.svg";